import React from 'react';
import { Link } from 'react-scroll'
import LinkedinIcon from '../../Resources/Icons/LinkedIn-Icon.svg';
import InstagramIcon from '../../Resources/Icons/Instagram-Icon.svg';
import GithubIcon from '../../Resources/Icons/Github-Icon.svg';
import '../../CSS/NavBar.css';

const MobileNavBar = () => {

    return (
        <nav className="Nav-bar">
            <ul className="Left">
                <li>
                    <Link 
                        className="Nav-button Home"
                        activeClass="active"
                        to="LandingPage"
                        spy={true}
                        smooth={true}
                        duration={200}
                        offset={-70}>
                        WILL LIAO
                    </Link>
                </li>
                <li>
                    <Link 
                        className="Nav-button"
                        to="AboutPage"
                        spy={true}
                        smooth={true}
                        duration={200}
                        offset={-40}>
                        About
                    </Link>
                </li>
                <li>
                    <Link 
                        className="Nav-button"
                        to="PortfolioPage"
                        spy={true}
                        smooth={true}
                        duration={200}
                        offset={-40}>
                        Portfolio
                    </Link>
                </li>
                {/*
                <li>
                    <Link 
                        className="Nav-button"
                        to="ContactPage"
                        spy={true}
                        smooth={true}
                        >
                        Contact
                    </Link>
                </li>
                */}
            </ul>

            <ul className="Right">
                <li>
                    <a href="https://www.linkedin.com/in/will-liao/">
                        <img src={LinkedinIcon} alt="LinkedIn" />
                    </a>
                </li>
                <li>
                    <a href="https://www.instagram.com/weillium/">
                        <img src={InstagramIcon} alt="Instagram" />
                    </a>
                </li>
                <li>
                    <a href="https://www.github.com/weillium/">
                        <img src={GithubIcon} alt="Github" />
                    </a>
                </li>
            </ul>
        </nav>
    )
}

export default MobileNavBar;